"use client";
import { useRouter } from "next/navigation";
import { ChevronLeft } from "lucide-react";
import { motion } from "framer-motion";
import logo from "@/assets/fresh0meat_logo.png";
import { Suspense } from "react";
import LazyImage from "@/components/LazyImage";


const AboutUsContent = () => {
    const navigate = useRouter();

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="min-h-screen bg-card pb-24"
        >
            <div className="container max-w-2xl mx-auto px-6 py-10 space-y-6">
                {/* Logo + Heading */}
                <div className="flex flex-col items-center gap-3 py-4">
                    <LazyImage src={logo.src} alt="Fresh O Meat Logo" width={200} height={60} className="w-full h-full object-contain" />
                    <h2 className="text-2xl font-extrabold text-foreground text-center">
                        Fresh O Meat PRIVATE LIMITED.
                    </h2>
                </div>

                {/* Body */}
                <p className="text-foreground/80 text-[15px] leading-relaxed">
                    Freshomeat was created with one simple mission: to deliver fresh,
                    hygienic, and high-quality raw chicken and meat straight to your
                    doorstep.
                </p>

                <p className="text-foreground/80 text-[15px] leading-relaxed">
                    We understand how important freshness and cleanliness are when it
                    comes to meat. That&apos;s why we source our products carefully,
                    follow strict hygiene standards, and ensure proper handling from farm
                    to delivery. Every order is cleaned, cut, and packed with care to give
                    you safe, tender, and delicious meat every time. With Freshomeat, you
                    no longer need to visit crowded markets or worry about quality. Our
                    fast and reliable delivery service ensures that you receive fresh meat,
                    on time, and at the best value. Freshomeat is not just a delivery
                    service — it&apos;s a promise of freshness, trust, and taste.
                </p>
            </div>
        </motion.div>
    );
};

export default function AboutUsPage() {
    return (
        <Suspense fallback={<div className="flex items-center justify-center min-h-[50vh]">
            <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        </div>}>
            <AboutUsContent />
        </Suspense>
    );
}
